import { Check, ArrowDown, FileCheck2 } from 'lucide-react';
import { Typography } from './Typography';
import styles from './WorkflowVisual.module.css';
export function WorkflowVisual({ steps, result }: { steps: string[]; result: string }) {
  return (
    <div className={styles.canvas}>
      <div className={styles.flow}>
        {steps.map((x, i) => (
          <div className={styles.stepGroup} key={x}>
            <div className={styles.step}>
              <span className={styles.number}>
                <Typography as="span" variant="small" tone="inherit">
                  {String(i + 1).padStart(2, '0')}
                </Typography>
              </span>
              <Typography variant="small">{x}</Typography>
              <Check size={15} aria-hidden />
            </div>
            {i < steps.length - 1 && <ArrowDown size={24} strokeWidth={1} aria-hidden />}
          </div>
        ))}
        <div className={styles.result}>
          <FileCheck2 size={18} aria-hidden />
          <Typography variant="small" tone="inherit">
            {result}
          </Typography>
        </div>
      </div>
    </div>
  );
}
